<template>
  <div class="row-out-right">
    <span style="font-size: 18px;font-weight: bold;margin-bottom: 4px;margin-top: 10px;">新闻资讯</span>
    <div class="row-cell-right" style="margin-bottom: 10px;"/>
    <div style="width: 100%" v-for="(item, index) in info" :key="item.id" >
      <div v-if="index <= 7" class="row-out-left-right-child" @click="_handleToDetail(item.ID)">
        <div class="title-cell">{{ item.post_title }}</div>
        <div class="cell-row">
          <span class="public-date">发布于 {{ item.post_date }}</span>
          <span class="public-date" style="margin-left: 20px;">浏览 {{ item.views_count }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/util/http"

export default {
  name: "RightNewsComponent",
  data() {
    return {
      info: []
    }
  },
  mounted() {
    this._getList()
  },
  methods: {
    _getList() {
      http.get('xinWenZiXunOut')
      .then((res) => {
        if (res.data.status === 0) {
          this.info = res.data.data
        }
      })
    },
    _handleToDetail(e) {
      let routeData = this.$router.resolve({
        path: "/DetailPage",
        query: {
          p: e
        }
      })

      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped>
.row-out-right {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 380px;
  margin-left: 20px;
  height: 100%;
}

.row-cell-right {
  width: 100%;
  height: 5px;
  background: #333333;
}

.row-out-left-right-child {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  height: 58px;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 8px;
  width: 100%;
  cursor: pointer;
}

.title-cell {
  margin-bottom: 12px;
  font-size: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.cell-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}

.public-date {
  font-size: 14px;
  color: #646363;
}
</style>